import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { FiChevronDown } from "react-icons/fi";
import AdminSidebarItem from "./AdminSidebarItem";
import { isSidebarItemActive } from "./adminNavigation";

const AdminSidebarSection = ({
  title,
  items,
  collapsed = false, // If true, the entire sidebar is in mini-icon mode
  onNavigate,
}) => {
  const location = useLocation();
  const [isExpanded, setIsExpanded] = useState(true);

  // Automatically expand the section if the user is currently on one of its pages
  useEffect(() => {
    const hasActiveItem = items?.some((item) =>
      isSidebarItemActive(location.pathname, item)
    );
    if (hasActiveItem) {
      setIsExpanded(true);
    }
  }, [location.pathname, items]);

  if (!items?.length) {
    return null;
  }

  // If the whole sidebar is minimized to just icons, we force show items 
  // so the user can still click the icons. Otherwise, respect accordion state.
  const showItems = isExpanded || collapsed;

  return (
    <section className="admin-sidebar__section">
      <button 
        type="button"
        className={`admin-sidebar__section-title ${isExpanded ? "is-expanded" : ""}`}
        onClick={() => setIsExpanded(!isExpanded)}
        aria-expanded={isExpanded}
      >
        <span>{title}</span>
        {!collapsed && (
          <FiChevronDown 
            size={14} 
            style={{ 
              transform: isExpanded ? 'rotate(0deg)' : 'rotate(-90deg)',
              transition: 'transform 0.2s ease',
              flexShrink: 0
            }} 
          />
        )}
      </button>
      
      {showItems && (
        <div className="admin-sidebar__section-items">
          {items.map((item) => (
            <AdminSidebarItem
              key={item.to}
              item={item}
              collapsed={collapsed}
              onNavigate={onNavigate}
            />
          ))}
        </div>
      )}
    </section>
  );
};

export default AdminSidebarSection;
